import {SET_IS_FETCHED_USERS, SET_USERS} from "@/store/modules/user/mutations";

export const FETCH_USERS = 'fetchUsers';

export default {
    async [FETCH_USERS]({commit}, params) {
        return axios.get('/web-api/user', {
            params: {
                ...params,
                include: 'roles',
            }
        })
            .then((response) => {
                commit(SET_USERS, response);
                commit(SET_IS_FETCHED_USERS, true);
            })
    }
}
